import { Checkbox, Drawer, Layout, Text } from '@loadsmart/miranda-react'
import type { Dispatch, SetStateAction } from 'react'

import type { BigNumber } from '../types'
import { getBigNumbersTitle } from '../utils'
import { ALL_ASSETS } from '../constants'

type BigNumbersDrawerProps = {
  open: boolean
  handleClose: () => void
  bigNumbers: BigNumber[]
  activeBigNumbers: BigNumber[]
  setActiveBigNumbers: Dispatch<SetStateAction<BigNumber[]>>
}

export function BigNumbersDrawer({
  open,
  handleClose,
  bigNumbers,
  activeBigNumbers,
  setActiveBigNumbers,
}: BigNumbersDrawerProps) {
  const handleOnChange = (bigNumber) => {
    setActiveBigNumbers((prevActiveBigNumbers) => {
      if (prevActiveBigNumbers.some((activeBigNumber) => activeBigNumber.name === bigNumber.name)) {
        return prevActiveBigNumbers.filter(
          (activeBigNumber) => activeBigNumber.name !== bigNumber.name
        )
      }
      return [...prevActiveBigNumbers, bigNumber]
    })
  }

  const isChecked = (bigNumber) => {
    return activeBigNumbers.some((activeBigNumber) => activeBigNumber.name === bigNumber.name)
  }

  return (
    <Drawer open={open} onClose={handleClose}>
      <Drawer.Header>
        <Text variant="heading-md-bold">Asset type views</Text>
        <Drawer.Close />
      </Drawer.Header>
      <Drawer.Body>
        <Layout.Stack>
          <Text variant="body-md">Choose which asset type views you would like to show</Text>
          <Layout.Stack>
            {bigNumbers.map((bigNumber) => (
              <Checkbox
                id={bigNumber.name}
                name={bigNumber.name}
                key={bigNumber.name}
                checked={isChecked(bigNumber)}
                onChange={() => handleOnChange(bigNumber)}
                disabled={bigNumber.name === ALL_ASSETS}
              >
                {getBigNumbersTitle(bigNumber.name)}
              </Checkbox>
            ))}
          </Layout.Stack>
        </Layout.Stack>
      </Drawer.Body>
    </Drawer>
  )
}
